import { JobsError, JobsLoaded, RequestJobs } from '../actions/jobs';

export default function jobs(state = null, action) {
  switch (action.type) {
    case RequestJobs: {
      return Object.assign({}, state, {
        error: null,
        lastUpdated: action.timestamp,
        loading: true,
      });
    }

    case JobsLoaded: {
      return Object.assign({}, state, {
        error: null,
        lastUpdated: action.timestamp,
        loading: false,
        jobs: action.jobs,
      });
    }

    case JobsError: {
      return Object.assign({}, state, {
        error: action.error,
        lastUpdated: action.timestamp,
        loading: false,
      });
    }

    default:
      return state;
  }
}
